module.exports = __webpack_public_path__ + "static/assets/57f35a541d4473896d0c80fa2625cd7f.gif";